export const SET_PRAESENZ_STATI = "setAnwesenheitStati";
